import {FirebaseApp, initializeApp} from 'firebase/app';
import {Database, getDatabase} from 'firebase/database';
import {environment} from 'environments/environment';

/**
 * Lazily initialises the Firebase app and Realtime Database.
 *
 * Replaces `AngularFireModule.initializeApp()` + `AngularFireDatabaseModule`, which came from
 * @angular/fire. That package peers `@angular/core ^20` and has no Angular 21 or 22 release, so it
 * was the hard ceiling on upgrading this workspace. The modular `firebase` SDK is not tied to an
 * Angular version and is already a direct dependency.
 *
 * Initialising lazily rather than at import time keeps the ordering safe: whichever service asks
 * first creates the app, and everyone afterwards shares it.
 */
let app: FirebaseApp;
let db: Database;

export function firebaseDb(): Database {
    if (!db) {
        app = initializeApp(environment.firebaseConfig);
        db = getDatabase(app);
    }
    return db;
}
